// extracted by mini-css-extract-plugin
module.exports = {"results":"ResultListPage_results__z54V0"};